import { Component, OnInit } from '@angular/core';
import { SimpleModalService } from '@looorent/ngx-simple-modal';
import { PermissionsService } from 'src/app/Services/permissions.service';
import { DataListFilterColumn, DatalastviewTextAndConditionalSuffixColumn, Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';
import { AddSessionComponent } from './modals/add-session/add-session.component';

@Component({
    selector: 'app-sessions',
    templateUrl: './sessions.component.html',
    styleUrls: ['./sessions.component.scss'],
    standalone: false
})
export class SessionsComponent implements OnInit {
  public ShowPermitFilter = false;
  public ShowRatesFilter = false;
  constructor(private permissionsService : PermissionsService, private modalService : SimpleModalService) { }

  public Columns : Array<Datalistviewcolumn> = [
    new DataListFilterColumn("Status", "Status", true, "Status"),
    new Datalistviewcolumn("Plate", "PlateNumbers"),
    new Datalistviewcolumn("Entry Lane", "EntryLaneName"),
    new DataListFilterColumn("Start Date", "StartDateLocalString", true, "StartDate"),
    new Datalistviewcolumn("Exit Gate", "ExitLaneName"),
    new DataListFilterColumn("End Date", "EndDateLocalString", true, "EndDate"),
    new DataListFilterColumn("Duration", "DurationAsString", true, "Duration"),
    new DatalastviewTextAndConditionalSuffixColumn("Rate", "ParkingRateSetName", "<i class=\"fa-regular fa-circle-check\" title='Validated'></i>", "Validated", true),
    new DataListFilterColumn("Paid", "TotalPaid", true, "Paid"),
    new Datalistviewcolumn("Controlled Area", "ControlledAreaName"),
  ];

  async ngOnInit(): Promise<void> {
    this.ShowPermitFilter = await this.permissionsService.CheckAdminPermission("PermitsFeature", 100);
    this.ShowRatesFilter = await this.permissionsService.CheckAdminPermission("RatesFeature", 100);
  }

  public async AddSession() {
     this.modalService.addModal(AddSessionComponent, {});
  }

}
